import React from 'react'
import {ReorderItemProps} from "../../../core/gd-ui/sortable-list-4/@types"
import PopoverMenu from "../../../core/gd-components/popover-menu/popover-menu/popover-menu";
import Navigation_BaseButton from "./base-button";
import {SpaceProto} from "../../../core/model2/space/space-proto";
import Navigation_ButtonHintSpace from "../components/hint/hint-space";
import {Position} from "../../../core/gd/const/position";
import {NavigationSectionType} from "../../../core/model2/navigation/@const";
import {AI_CHAT_AGENT_CHANGED, AI_CHAT_LAST_AGENT_KEY} from "../../../core/gd-modules/ai-chat/ai-chat";
import AiAgentAvatar from "../../../app/ai-chat/components/agent-avatar";

type Props = {
    className?          : string,
    space               : SpaceProto,
    onClickCallback?    : callback,

    hintPosition?       : Position,
    showLabel?          : boolean,

} & ReorderItemProps

// const debug = "Navigation_ButtonGeneric"
const debug = false

export default class Navigation_ButtonSpace extends React.Component<Props> {

    public refHint                  : React.RefObject<Navigation_ButtonHintSpace> = React.createRef<Navigation_ButtonHintSpace>()

    static defaultProps = {
        showLabel            : true
    }

    componentDidMount() {
        if (this.props.space.id === NavigationSectionType.AI_CHAT) {
            gd.bus.subscribe(AI_CHAT_AGENT_CHANGED, this, this.onAgentChanged)
        }
    }

    componentWillUnmount() {
        if (gd.layout.contextMenu.hover?.component === this) {
            gd.layout.contextMenu.hover.component = null
            gd.layout.contextMenu.hide()
        }
        gd.bus.unsubscribe(this)
    }

    onAgentChanged = () => {
        this.forceUpdate()
    }

    showContextMenu = (e: React.MouseEvent) => {

        e.stopPropagation()
        e.preventDefault()

        const options : Options = this.props.space.contextMenuOptions
        if (_.size(options) < 1) {
            return null
        }

        debug && console.log(debug, 'showContextMenu', e)

        gd.layout.contextMenu.show(e,
            <PopoverMenu options        = {options}
                         className      = "min-w-220i"
                         hidePopover    = {() => gd.layout.contextMenu.hide()}/>,
            {
                component: this
            }
        )
    }

    onClick = (e:React.MouseEvent) => {
        debug && console.log(debug, 'onClick', e)

        e.stopPropagation()

        if (this.props.onClickCallback) this.props.onClickCallback()

        this.refHint?.current?.hideHint()

        this.props.space.navigation.onClick && this.props.space.navigation.onClick()
    }

    render() {
        const isSelected = gd.layout.navigation.state.currentSection?.id === this.props.space.id   // yes by id not object

        // Old
        // let icon = (this.props.section.iconActive && isSelected && !this.props.inMorePopover) ? this.props.section.iconActive : this.props.section.icon

        // New
        let icon = this.props.space.navigation.icon

        let iconComponent: React.ReactNode | undefined = undefined
        if (this.props.space.id === NavigationSectionType.AI_CHAT) {
            const agentId = localStorage.getItem(AI_CHAT_LAST_AGENT_KEY) as ID | null
            if (agentId) {
                iconComponent = <AiAgentAvatar agentId={agentId} size={20} noBackground/>
            }
        }

        const showHintButton = !this.props.space.inNavigationMore && !this.props.dndIsDragInProgress

        let label = undefined
        if (this.props.showLabel) {
            label = this.props.space.navigationPanelLabel || undefined
        }

        // style is required for ReorderList (pointer-events: none)
        return (
            <Navigation_BaseButton
                className           = {this.props.className}
                icon                = {iconComponent ? undefined : icon}
                iconComponent       = {iconComponent}
                label               = {label}
                style               = {this.props.style}
                isSelected          = {isSelected}
                dndPreview          = {this.props.dndPreview}
                dndIsDragged        = {this.props.dndIsDragged}
                inMorePopover       = {this.props.space.inNavigationMore}
                dndIsDragInProgress = {this.props.dndIsDragInProgress}
                isMouseEntered      = {this.props.isMouseEntered}
                onClick             = {this.onClick}
                showContextMenu     = {this.showContextMenu}
            >
                {showHintButton &&
                    <Navigation_ButtonHintSpace ref={this.refHint}  space={this.props.space} position={this.props.hintPosition} />
                }

            </Navigation_BaseButton>
        )
    }
}
